export default __webpack_public_path__ + "static/media/card-discover.67f0453f.svg";